// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d_9DIIs09VbUKK {\n  line-height: 1;\n  background-color: rgba(9, 30, 66, 0.04);\n  align-items: center;\n  justify-content: center;\n}\n.d_9DIIs09VbUKK:hover {\n  background-color: rgba(9, 30, 66, 0.08);\n}\n.d_9DIIs09VbUKK:active {\n  background-color: rgba(9, 30, 66, 0.13);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"assigneeBadge": "d_9DIIs09VbUKK"
};
export default ___CSS_LOADER_EXPORT___;
